<app-join-apply-modal></app-join-apply-modal>

<div class="flex h-100">
  <div [ngClass]="isCollapsed ? 'w0 overflow-hidden' : 'w236'" class="sidebar">
    <app-sidebar></app-sidebar>
  </div>
  <div class="flex direction-column flex-1" [ngStyle]="{width: isCollapsed ? '100%' : 'calc(100% - 236px)'}">
    <app-header></app-header>
    <div class="flex-1 ph24 bg_color_f0f2f5" [ngClass]="isHiddenFlag ? 'overflow-hidden' : 'overflow-auto'">
      <router-outlet></router-outlet>
    </div>
  </div>
</div>